import { useEffect } from 'react';

import toast from 'components/partials/toast/toast';

import { getApiErrorDetail } from 'helpers/api/get-api-error-detail';

import { MONITORING_ERROR_TOAST_FALLBACK } from 'containers/user/critical-elements-monitoring/monitoring-constants';

export const useMonitoringErrorToast = (
  error: unknown,
  title: string
): void => {
  useEffect(() => {
    if (!error) return;

    toast.error({
      title,
      message: getApiErrorDetail(error, MONITORING_ERROR_TOAST_FALLBACK),
    });
  }, [error, title]);
};
